module.exports = new __parcel__URL__("in-rainbows.edcee051.jpg").toString();